﻿import * as $ from 'jquery';
import { bind, canWrite, Binding } from 'common/dom/binding';
import { Observable } from 'common/barrels/rx';

export function numberbox(value: Binding<number>) {
    const $input = $('<input type="text" />');

    if (!canWrite(value))
        $input.attr('readonly', 'true');

    const updateIfDifferent = x => {
        const existing = $input.val();

        if (existing !== x && coerce(existing) !== x) {
            $input.val(x);
            $input.trigger('input');
        }
    };

    $input.owns(bind<number>(value, updateIfDifferent, () => getControlValues($input)));

    return $input;
}

function getControlValues($input: JQuery) {
    let reverting = false;
    const initialValue = $input.val();
    const raw = Observable.fromEvent<any>($input, 'input propertychange').filter(() => !reverting).map(() => $input.val());
    const [valid, invalid] = raw.partition(x => isValid(x));
    const revertTrigger = invalid.filter(x => x !== '-').merge(Observable.fromEvent<any>($input, 'blur').whereLatest(raw.map(x => !isValid(x))));

    $input.owns(revertTrigger.withLatestFrom(valid.startWith(initialValue), (i, v) => v).subscribe(x => {
        reverting = true;
        $input.val(x);
        reverting = false;
    }));

    return valid.map(x => coerce(x));
}

function coerce(x: string): number {
    return x === null ? null
         : x === undefined ? undefined
         : x === '' ? null
         : +x;
}

function isValid(value: string) {
    return value === null ? true
         : value === undefined ? true
         : value === '' ? true
         : value !== value.trim() ? false
         : value.startsWith('0') && value.length > 1 ? false
         : !isNaN(+value);
}